// extracted by mini-css-extract-plugin
export default {"thread-select":"styles_thread-select__JuUeT"};